/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3.5 5L8 10l4.5-5h-9z" _fill="#0071B3" fill-opacity=".8"/>'
  }
})
